var cov_1tsh294r6v = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Transfer/styles/index.ts",
      hash = "3c20c0500595f1e5ceafa73855a387b4469cb4b5",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Transfer/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 5,
          column: 65
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var transferLess = {};
import genaration from '../../utils/classname';
export var transferClass = (cov_1tsh294r6v.s[0]++, genaration(transferLess, 'transfer'));